export const AionMark = ({ compact = false }: { compact?: boolean }) => (
  <div className={`aion-mark ${compact ? "aion-mark--compact" : ""}`}>
    <span className="aion-mark__sun" aria-hidden="true">
      <i />
    </span>
    <span className="aion-mark__word">Aion</span>
  </div>
);

